<app-poster-badge *ngIf="showPosterBadge" [sender]="'bot'" [service]="service"
  [attr.aria-label]="'aria.label.posterBadgeFromBot' | translate"></app-poster-badge>
<form [class.done]="readOnly" aria-labelledby="form-title">
  <h2 *ngIf="title" id="form-title">{{ title }}</h2>
  <div class="row" *ngFor="let row of layout; let i = index">
    <ng-container *ngFor="let field of row; let j = index">
      <ng-container *ngIf="field?.message && shouldRenderQuestion(i, j)">
        <div class="static-output" [class.heading]="field.isHeading" *ngIf="field.message.format === 'plain'"
          role="region" aria-live="polite">
          <mat-icon aria-hidden="true"> info </mat-icon>
          <div [innerHTML]="field.message.content | sanitizeHtml"></div>
        </div>
        <app-question-answers (answered)="fieldEntered(field, $event)" (hasError)="field.error = $event" [inline]="true"
          [parser]="parser" [message]="field.message" [initialValue]="field.value || undefined"
          *ngIf="field.message.format !== 'plain'" [service]="service"
          [ariaDescribedBy]="field.error ? 'error-field-' + field.refId : null"></app-question-answers>
      </ng-container>
    </ng-container>
  </div>
  <button mat-raised-button color="primary" (click)="continue()" [disabled]="!isValid"
    *ngIf="!readOnly && !hideContinue" [attr.aria-label]="'aria.label.continue' | translate">
    {{ "common.button.continue" | translate }}
  </button>
  <mat-spinner [diameter]="20" style="margin: 10px auto" *ngIf="uploadingFiles" role="status" aria-live="polite"
    [attr.aria-label]="'aria.label.uploadingFiles' | translate"></mat-spinner>
</form>